/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    value: [],
};
export const completedStagesSlice = createSlice({
    name: 'completedStagesReducer',
    initialState,
    reducers: {
        updateStages: (state, action) => {
            state.value = Array.from(new Set([...state.value, action.payload]));
        },
        batchUpdateStages: (state, action) => {
            state.value = Array.from(new Set([...state.value, ...action.payload]));
        },
        removeStage: (state, action) => {
            state.value = state.value.filter((stage) => stage !== action.payload);
        },
        removeStageAndAfter: (state, action) => {
            const stagesArray = Array.from(new Set([...state.value]));
            const index = stagesArray.indexOf(action.payload);
            if (index !== -1) {
                state.value = stagesArray.splice(0, index);
            }
        },
    },
});
export const { updateStages, removeStage, removeStageAndAfter, batchUpdateStages, } = completedStagesSlice.actions;
export const setStageComplete = (value) => (dispatch) => Promise.resolve(dispatch(updateStages(value)));
export const setStageIncomplete = (value) => (dispatch) => Promise.resolve(dispatch(removeStage(value)));
export const setStageIncompleteAndRemoveFollowing = (value) => (dispatch) => Promise.resolve(dispatch(removeStageAndAfter(value)));
export const getCompletedStages = (state) => state.completedStages.value;
export default completedStagesSlice.reducer;
